import { CertificateRequestStatus } from "@tfg/db"
import { DEFAULT_PAGE_SIZE } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { queryClient } from "~/backend/queryClient"
import {
  certificateRequestDtoStatusEnum,
  findCertificateRequestsByCertificateIdQueryKey,
  findCertificatesByOrganizationIdQueryKey,
  useUpdateManyCertificateRequests,
} from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export type Props = {
  certificateId: string
  onSettled: () => void
}

export const useUpdateCertificateRequestsMutation = ({
  certificateId,
  onSettled,
}: Props) => {
  const { t } = useTranslation("certificates")

  return useUpdateManyCertificateRequests({
    mutation: {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries({
          queryKey: findCertificatesByOrganizationIdQueryKey({
            pagination: {
              pageIndex: 0,
              pageSize: DEFAULT_PAGE_SIZE,
            },
          }),
        })
        queryClient.invalidateQueries({
          queryKey: findCertificateRequestsByCertificateIdQueryKey({
            certificateId,
            status: [
              CertificateRequestStatus.SUBMITTED,
              CertificateRequestStatus.ACCEPTED,
              CertificateRequestStatus.REJECTED,
            ],
          }),
        })
        showSuccessNotification({
          title:
            variables.data.update.status ===
            certificateRequestDtoStatusEnum.ACCEPTED
              ? t("modal.successAccept")
              : t("modal.successReject"),
          message:
            variables.data.update.status ===
            certificateRequestDtoStatusEnum.ACCEPTED
              ? t("modal.successAccept")
              : t("modal.successReject"),
        })
      },
      onSettled,
      onError: (error) => {
        showAxiosError({
          error,
          notificationTitle: t("modal.error"),
          showNotification: true,
        })
      },
    },
  })
}
